<script setup lang="ts">
import { useSettings } from '@base/composables/settings'
import { ut_wilo_filteredCountryData, ut_wilo_getFrequency, ut_wilo_modifyCountry } from '~/utils/utils'

defineProps<{
  isHistoric: boolean
  realCountry: string
}>()

onMounted(() => {
  if (!cp.rcre1Value.value) {
    cp.rcre1Value.value = ut_wilo_getFrequency()
  }
})

const cp = useSettings()
const inputDate = shallowRef(cp.dateValue.value)
const inputDateRef = useTemplateRef('inputDateRef')
</script>

<template>
  <div class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-4 overflow-x-auto">
    <USelect
      v-if="cp.countryData.value"
      :default-value="realCountry"
      :items="ut_wilo_filteredCountryData(cp.countryData.value)"
      @update:model-value="cp.changeLangCountry('rcco', ut_wilo_modifyCountry($event, isHistoric))"
    />
    <USelect
      v-if="cp.langData.value"
      :default-value="cp.langValue.value"
      :items="cp.langData.value"
      @update:model-value="cp.changeLangCountry('lcda', $event)"
    />

    <USelect
      v-if="cp.stageData.value"
      :default-value="cp.stageValue.value"
      placeholder="stage"
      :items="cp.stageData.value"
      @update:model-value="cp.changeRest('stage', $event)"
    />

    <USelect
      v-if="cp.rcre1Data.value"
      v-model="cp.rcre1Value.value"
      placeholder="rcre1"
      :items="cp.rcre1Data.value"
      @update:model-value="cp.changeRest('rcre1', $event)"
    />

    <UInputDate
      ref="inputDateRef"
      v-model="inputDate"
      range
      :disabled="cp.indexStore.state.isLoading"
    >
      <template #trailing>
        <UPopover :reference="inputDateRef?.inputsRef[0]?.$el">
          <UButton
            color="neutral"
            variant="link"
            size="sm"
            icon="i-wilo-calendar-days-solid-full"
            aria-label="Select a date range"
          />

          <template #content>
            <UCalendar v-model="inputDate" class="p-2" :number-of-months="2" range />
          </template>
        </UPopover>
        <UButton class="cursor-pointer" icon="i-wilo-chevron-right-solid-full" color="tertiary" variant="outline" size="xs" @click="cp.changeDate(inputDate)" />
      </template>
    </UInputDate>

    <USelect
      v-if="cp.dopsData.value"
      multiple
      selected-icon="i-wilo-check-solid-full"
      :default-value="cp.dops.value"
      placeholder="dops"
      :items="cp.dopsData.value"
      @update:model-value="cp.changeDops($event)"
    />

    <div class="css-xs">
      <div>Production date: {{ cp.sysInfo.value?.productionDate }}</div>
      <!--      <div>Build: {{ cp.infoData.value?.build }}</div>
      <div>Version: {{ cp.infoData.value?.version }}</div> -->
    </div>

  </div>
</template>
